import React from "react";

const Footer = () => {
  return (
    <footer className="bg-slate-800 text-slate-300 py-6">
      <div className="container mx-auto text-center">
        <p>© 2025 Yakshaloka. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
